import { render } from "./TextInputNumber.vue?vue&type=template&id=270b5a70"
import script from "./TextInputNumber.vue?vue&type=script&lang=js"
export * from "./TextInputNumber.vue?vue&type=script&lang=js"

import exportComponent from "/Users/mda/www/akademia-taletow/spa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__